export const setAllUsers = allUsers => ({
  type: 'SET_ALL_USERS',
  allUsers,
});

export const cleanSessionAdmin = () => ({
  type: 'CLEAN_ADMIN'
})
